import { useTimeSlot } from '@/hooks/useTimeSlot'
import { add, max, startOfDay, sub } from 'date-fns'
import { computed, ref } from 'vue'
import type { FetchAvailableTimeSlotQueryVariables } from './TimeSlotPickerModal.generated'

type Range = FetchAvailableTimeSlotQueryVariables

const computeDays = (_start: Date, length: number): Date[] => {
  const start = startOfDay(_start)
  return Array.from({ length }, (_empty, index) => add(start, { days: index }))
}

const { unavailableDurationFromNow } = useTimeSlot()

export const useTimeSlotPickerQueryVars = (chunkSize: number) => {
  const now = new Date()
  const base = add(now, unavailableDurationFromNow)
  const cursor = ref(base)
  const daysInRange = computed(() => computeDays(cursor.value, chunkSize))
  const until = computed(() =>
    add(startOfDay(cursor.value), { days: chunkSize })
  )

  const range = computed(
    (): Range => ({
      from: cursor.value.toISOString() as TimeString,
      until: until.value.toISOString() as TimeString,
    })
  )

  const hasPrev = computed(() => cursor.value > base)
  const next = () => {
    cursor.value = until.value
  }
  const prev = () => {
    cursor.value = max([base, sub(cursor.value, { days: chunkSize })])
  }

  return { range, daysInRange, hasPrev, next, prev }
}
